import { createConsumer } from '@rails/actioncable';
import buildCableUrl from './lib/buildCableUrl';

// One connection per tab. Features own their subscriptions; the app session
// owns disconnecting the transport. createConsumer is lazy until subscribed.
const cable = createConsumer(buildCableUrl);

export default cable;
